export default function Guest({ next }) {
  return next()
}
